import { clsx } from 'clsx';
import * as styles from './styles.css';
import { IFourthUtpBlock } from 'shared/types/utp';
import { useDeviceType } from '@cian/ui-kit';

interface IFourthUtpBlockProps {
  utp: IFourthUtpBlock[];
}

export const FourthUtpBlock: React.FC<IFourthUtpBlockProps> = ({ utp }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['list'], styles[device])}>
      {utp.map(({ title, image }, key) => (
        <div key={key} className={clsx(styles['item'], title.isBold && styles['bold'])}>
          <div className={styles['item-title']}>{title.value}</div>
          {image && <div className={clsx(styles['image'], styles[image])} />}
        </div>
      ))}
    </div>
  );
};
